import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import ContentLandingPageWrapper from '../Components/ContentLandingPageWrapper';
import ButtonGroup from '../Components/ButtonGroup';
import Button from '../Components/Button';
import Fonts from '../Styles/Fonts';
import Colors from '../Styles/Colors';

const Title = styled.h2`
    ${Fonts.merriweather.bold};
    color: ${Colors.white};
    font-size: 19px;
    margin: 0 0 5px 0;
    line-height: 1;
    text-align: center;
`;
const Address = styled.div`
    color: ${Colors.white};
    text-align: center;
    line-height: 1.3125;
    margin-bottom: 19px;
`;
const MapContainer = styled.div`
    margin: 24px -14px 0;
`;
const MapLink = styled.a``;
const MapImage = styled.img`
    max-width: 100%;
`;

class EventInfoVenueInfoPage extends Component {
  componentDidMount = () => {
  };

  formatAddress = () => {
      if (this.props.content) {
          return (
              <div>
                { this.props.content.address }<br />
                { this.props.content.city }, { this.props.content.state } {this.props.content.zip}
            </div>
          )
      } else {
          return null;
      }
  };

    render() {
        const title = (this.props.content && this.props.content.name) ? this.props.content.name : "";
        const url = (this.props.content && this.props.content.url) ? this.props.content.url : false;
        const phone = (this.props.content && this.props.content.phone) ? this.props.content.phone : false;
        const phoneRaw = (this.props.content && this.props.content.phone) ? this.props.content.phone.replace(/\D/g,'') : false;
        const mapUrl = (this.props.content && this.props.content.map_url) ? this.props.content.map_url : false;
        return (
            <ContentLandingPageWrapper headerTitle="Event Info" headerSubtitle="Venue" fullWidth={true}>
                <Title>{ title }</Title>
                <Address>{ this.formatAddress() }</Address>
                <ButtonGroup>
                    { mapUrl &&
                        <Button href={ mapUrl } target="_blank">Get Directions</Button>
                    }
                    
                    { phone &&
                        <Button href={`tel:${phoneRaw}`}>{ phone }</Button>
                    }
                    

                    { url &&
                        <Button href={ url } target="_blank">Visit Website</Button>
                    }
                </ButtonGroup>
                <MapContainer>
                    <MapLink href="/_assets/img/passport-app/acic-lcs-map.jpg" target="_blank"><MapImage src="/_assets/img/passport-app/acic-lcs-map-thumb.png" /></MapLink>
                </MapContainer>
            </ContentLandingPageWrapper>
        );
    }
}

const mapStateToProps = (state) => {
  return {
      content: state.content.eventInfoVenueInfoContent
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      performDispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventInfoVenueInfoPage);